import { useTranslation } from 'react-i18next';
import { useUgcDraft } from '../../../../models/ugc-draft/context';
import {
  PlainEditor,
  PlainEditorProps,
} from '../../../../components/ui/plain-editor';
import { MAXIMUM_DESCRIPTION_LENGTH } from '../../../../models/ugc-draft/context';
import '../form.scss';

const trackingContext: PlainEditorProps['trackingContext'] = {
  contentSection: 'description',
};

const DescriptionInput = () => {
  const { ugcDraft, isPersisting, updateUgcDraftFormState } = useUgcDraft();
  const { t } = useTranslation();

  const onTextChange = (description: string) => {
    updateUgcDraftFormState({ description });
  };

  return (
    <PlainEditor
      className={'ugc-editor description'}
      aria-label={t('ugc_draft.field_description')}
      disabled={isPersisting}
      defaultValue={ugcDraft.description || ''}
      maximumCharacter={MAXIMUM_DESCRIPTION_LENGTH}
      onChange={onTextChange}
      placeholder={t('ugc_draft.field_description_placeholder')}
      trackingContext={trackingContext}
    />
  );
};

export default DescriptionInput;
